import type { EncounterLabOrder, EncounterStudy } from '../../ConsultationOrders';
import type { EncounterOrder, OrderKind } from './types';

export interface OrderSummaryEncounter {
  labOrders?: EncounterLabOrder[];
  radiologyStudies?: EncounterStudy[];
  clinicalOrders?: EncounterOrder[];
}

export interface OrderSummaryRow {
  key: string;
  label: string;
  status: string;
  outside: boolean;
  quantity: number;
}

export function orderSummaryRows(encounter: OrderSummaryEncounter, kind: OrderKind): OrderSummaryRow[] {
  const lines = (encounter.clinicalOrders ?? [])
    .filter((order) => order.type === kind && order.status !== 'cancelled')
    .flatMap((order) =>
      order.items.filter((item) => item.status !== 'cancelled').map((item, index) => ({ order, item, key: item.id ?? `${order.id}:${index}` })),
    );
  const outside = lines
    .filter(({ item }) => item.fulfilment === 'outside')
    .map(({ item, key }) => ({ key, label: item.label, status: 'outside', outside: true, quantity: item.quantity ?? 1 }));
  if (kind === 'lab') {
    const inHouse = (encounter.labOrders ?? []).flatMap((order) =>
      order.items.filter((item) => item.status !== 'cancelled').map((item) => ({ key: item.id, label: item.test.name, status: item.status, outside: false, quantity: 1 })),
    );
    return [...inHouse, ...outside];
  }
  if (kind === 'radiology') {
    const inHouse = (encounter.radiologyStudies ?? [])
      .filter((study) => study.status !== 'cancelled')
      .map((study) => ({ key: study.id, label: study.studyType.name, status: study.status, outside: false, quantity: 1 }));
    return [...inHouse, ...outside];
  }
  return lines.map(({ order, item, key }) => ({
    key,
    label: item.label,
    status: item.fulfilment === 'outside' ? 'outside' : (order.status ?? 'ordered'),
    outside: item.fulfilment === 'outside',
    quantity: item.quantity ?? 1,
  }));
}

export function orderLineCount(encounter: OrderSummaryEncounter, kind: OrderKind): number {
  return orderSummaryRows(encounter, kind).length;
}
